module.exports = __webpack_public_path__ + "img/gear.630e43a3.svg";